<template>
        <multiselect
                v-model="selected"
                label="city"
                track-by="id"
                placeholder="Seleziona un comune"
                :options="options_data"
                selectLabel="Invio per selezionare"
                :multiple="false"
                :searchable="true"
                :loading="isLoading"
                :internal-search="true"
                :clear-on-select="false"
                :close-on-select="true"
                :options_data-limit="3"
                :limit="10"
                :limit-text="limitText"
                :max-height="2000"
                :show-no-results="false"
                :hide-selected="false"
                :preserve-search="true"
                @input="notify"
        >
            <span slot="noResult">{{ $t("message.not_found_search") }}</span>
            <span slot="noOptions">Non ci sono risultati disponibili</span>
        </multiselect>
</template>
<script>
    import Multiselect from "vue-multiselect";
    import axios from "axios";

    export default {
        components: {Multiselect},
        data() {
            return {
                selected: null,
                selected_id: -1,
                options_data: [],
                isLoading: false
            };
        },
        props: ["value", "cityName", "provincia"],
        watch: {
            value: function (v2, v1) {
              this.selected = v2;
            },
            cityName: function (v2, v1) {
                this.populate();
            },
            provincia: function (v2, v1) {
                this.populate();
            }
        },
        methods: {
            notify: function (value, id) {
                    this.selected_id = this.selected ? this.selected.id : -1;
                    this.$emit("input", this.selected);
                    this.$emit("city", this.selected);
            },
            limitText: function (count) {
                return `e ${count} altre destinazioni`;
            },
            selectByCityName: function () {
                let params = {};
                let self = this;

                if (self.cityName && self.cityName.length >= 2) {
                    params.name = self.cityName;

                    if (self.provincia > 0) {
                        params.provincia = self.provincia;
                    }

                    this.apiCall(params, function (data, params) {
                        self.populateComboBox(data, params);

                        if (self.options_data.length == 1) {
                            self.selected = self.options_data[0];
                            self.selected_id = self.selected.id;
                        } else {
                            self.selected = null;
                            self.selected = _(self.options_data).find(function (o) {
                                return o.city == self.cityName;
                            });
                            if (self.selected !== null) {
                                self.selected_id = self.selected.id;
                            }
                        }
                        self.notify();
                    });
                }
               },
               populate: async function(){
const self = this;
                  self.isLoading = true;

            var config = {
                        method: "get",
                        url: self.$url + "operations/comuni",
                        headers: self.$config.axiosHeaders()
                    };

            let params = null;
                if (self.cityName && self.cityName.length >= 2) {
                    params = params || {};
                    params.name = self.cityName;
                }
                    if (self.provincia > 0) {
                        params = params || {};
                        params.provincia = self.provincia;
                    }

            const data = await axios(config);

            if( data && data.data && data.data.data){
                this.options_data = [... data.data.data ];
            }else{
              this.options_data = [];
            }
            self.isLoading = false;
               }
            },

        async created() {
            this.selected = this.value || null;
            this.selected_id = this.selected ? this.selected.id: -1;
            return this.populate();
        }
    }; // export
</script>
